import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
import AdmissionApplicationForm from "../../components/AdmissionApplicationForm";
import useScrollAnimation from "../../constants/useScrollAnimation";
import "./ContactPage.css";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const ContactPage = () => {
  const location = useLocation();
  const { school_slug } = useParams();

  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);
  const [timings, setTimings] = useState([]);

  const [contentRef, isContentVisible] = useScrollAnimation(0.2);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios.get(
      `${baseAPIUrl}api/general_settings/get_general_settings/${finalSchoolSlug}`
    )
      .then(res => {
        if (res.data.status === 1) {
          setInfo(res.data.data.settings);
          setTimings(res.data.data.timings || []);
        }
      })
      .catch(err => console.error("CONTACT API ERROR:", err))
      .finally(() => setLoading(false));
  }, [school_slug]);

  return (
    <div className="contact-page">
      <SchoolInnerPageBanner/>

      {/* CONTACT FORM SECTION */}
      <div id="contact-us" className="contact-page-section">
        <div className="container contact-page-container">
          
          <div ref={contentRef} className="row mt-5">
            {/* FORM LEFT SIDE */}
            <div className={`col-md-8 schools-left ${isContentVisible ? "animate-in" : ""}`}>
              {/* GOOGLE MAP SECTION */}
              {info?.map_url && (
                <iframe
                  src={info.map_url}
                  width="100%"
                  height="535"
                  className="contact-page-map"
                  loading="lazy"
                ></iframe>
              )}
            </div>

            {/* CONTACT INFO RIGHT SIDE */}
            <div className="col-md-4">
              <div className="contact-page-info-box">
                <div className={`schools-right ${isContentVisible ? "animate-in" : ""}`}>
                  <h3 className="contact-page-info-title">
                    Contact Information
                  </h3>

                  <div className="contact-page-info-group">
                    <h5 className="contact-page-info-label">Head Office</h5>
                    <p>
                      {info?.address}
                    </p>
                  </div>

                  <div className="contact-page-info-group">
                    <h5 className="contact-page-info-label">Phone</h5>
                    <p>{info?.phone}</p>
                  </div>

                  <div className="contact-page-info-group">
                    <h5 className="contact-page-info-label">Email</h5>
                    <p>{info?.email}</p>
                  </div>

                  <div>
                    <h5 className="contact-page-info-label">Office Hours</h5>
                    {timings.map((t, i) => (
                      <p key={i}>
                        <strong>{t.day_label}</strong>: {t.time_label}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>

    </div>
  );
};

export default ContactPage;
